export default "__VITE_ASSET__CkCxKsGv__"